// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkout__btn--next[data-v-2f837602]{margin-top:var(--spacing-md-1)}.checkout__text[data-v-2f837602]{background-color:var(--overlay-background);color:var(--color-text-1);font-size:20px;font-weight:700;padding-top:100px;position:relative;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
